import { Action } from "redux";
import { ITranslations } from "@montana/models/generated/cms.interface";

export enum TranslationsAction {
    FETCH_SUCCESS = "@@translations/FETCH_SUCCESS",
    FETCH_FAILURE = "@@translations/FETCH_FAILURE"
}

export type ITranslationsSuccessAction = IFetchTranslationsSuccessAction;

export interface IFetchTranslationsSuccessAction extends Action<TranslationsAction.FETCH_SUCCESS> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload: ITranslations;
}

export type ITranslationsFailureAction = IFetchTranslationsSuccessAction;


// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchTranslationsSuccess = (translations: ITranslations): IFetchTranslationsSuccessAction => ({
    type: TranslationsAction.FETCH_SUCCESS,
    payload: translations,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const fetchTranslationsFailure = (): Action<TranslationsAction.FETCH_FAILURE> => ({
    type: TranslationsAction.FETCH_FAILURE,
});
